// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".input-right[data-v-251cab67] input{text-align:right}", "",{"version":3,"sources":["webpack://./resources/js/components/SubscriptionOrder/Form.vue"],"names":[],"mappings":"AAEE,oCACE,gBADJ","sourcesContent":["\n.input-right {\n  :deep(input) {\n    text-align: right;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
